import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { BlocksModule, CmSharedModule, DataModule, InputModule, PanelsModule } from '@r1-development/rps-shared-ui';
import { AgGridModule } from 'ag-grid-angular';
import 'ag-grid-enterprise';
import { CodeEditorComponent, ContractSelectionGridComponent, SplitterComponent } from './components';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { SplitterPanelDirective } from './components/splitter/splitter-panel.directive';
import { ScrollSpyDirective } from './directives';
import { FormFieldComponent } from './form-field/form-field.component';
import { MaterialModule } from './material.module';
import {
  ArrayIncludesPipe,
  ClusterStatusBadgePipe,
  ContractHrefPipe,
  EnumEqualPipe,
  EnumToStringPipe,
  EstimatedOppUsedPipe,
  FilterQueueTenantPipe,
  FormatDate,
  FormatDateTime,
  HtmlListDisplayPipe,
  SerializedComparatorPipe,
  StartCasePipe,
} from './pipes';
import { BooleanCellComponent } from './utils/cell-renderers/boolean-cell/boolean-cell.component';
import { DateCellComponent } from './utils/cell-renderers/date-cell/date-cell.component';
import { DeleteCellComponent } from './utils/cell-renderers/delete-cell/delete-cell.component';
import { IconCellComponent } from './utils/cell-renderers/icon-cell/icon-cell.component';
import { InputCellComponent } from './utils/cell-renderers/input-cell/input-cell.component';
import { LinkCellComponent } from './utils/cell-renderers/link-cell/link-cell.component';
import { RouteLinkCellComponent } from './utils/cell-renderers/route-link-cell/route-link-cell.component';
import { ShiftGroupPlaceholderCellComponent } from './utils/cell-renderers/shift-group-placeholder-cell/shift-group-placeholder-cell.component';
import { ToggleSwitchCellComponent } from './utils/cell-renderers/toggle-switch-cell/toggle-switch-cell.component';

const modules = [
  AgGridModule,
  CommonModule,
  FormsModule,
  MaterialModule,
  ReactiveFormsModule,
  RouterModule,
  // Cloudmed UI Modules
  BlocksModule,
  CmSharedModule,

  DataModule,

  InputModule,
  PanelsModule,

  CodemirrorModule,
];

const components = [
  BreadcrumbComponent,
  CodeEditorComponent,
  ContractSelectionGridComponent,
  BooleanCellComponent,
  DateCellComponent,
  DeleteCellComponent,
  FormFieldComponent,
  IconCellComponent,
  InputCellComponent,
  LinkCellComponent,
  ShiftGroupPlaceholderCellComponent,
  SplitterComponent,
  ToggleSwitchCellComponent,
  RouteLinkCellComponent,
];

const pipes = [
  EnumEqualPipe,
  EnumToStringPipe,
  ArrayIncludesPipe,
  ClusterStatusBadgePipe,
  ContractHrefPipe,
  EstimatedOppUsedPipe,
  FormatDate,
  FormatDateTime,
  FilterQueueTenantPipe,
  HtmlListDisplayPipe,
  StartCasePipe,
  SerializedComparatorPipe,
];

@NgModule({
  imports: [...modules],
  providers: [...pipes, DecimalPipe],
  declarations: [...components, ...pipes, ScrollSpyDirective, SplitterPanelDirective],
  exports: [...modules, ...components, ...pipes, SplitterPanelDirective],
})
export class SharedModule {}
